module.exports = __webpack_public_path__ + "static/media/skiing.48676c04.mp4";